module.exports = __webpack_public_path__ + "img/Brazil.26fa2d24.svg";